/**
 * Helpers for institute attachment preview/download URLs.
 */

export function isExternalAttachmentUrl(value?: string | null): boolean {
	if (!value) return false;
	return /^https?:\/\//i.test(value.trim());
}

export function normalizeAttachmentKey(value?: string | null): string | undefined {
	if (!value?.trim()) return undefined;
	return value.trim().replace(/^\/+/, "");
}

/**
 * Encode object keys for GET /institutes/attachments/:objectKey routes.
 * Nested keys like uploads/results/1942/file.pdf must be a single path segment.
 */
export function buildAttachmentPreviewPath(objectKey: string): string {
	return encodeURIComponent(normalizeAttachmentKey(objectKey) ?? objectKey);
}

export function buildAttachmentPreviewUrl(basePath: string, objectKey: string): string {
	const normalizedBase = basePath.replace(/\/+$/, "");
	return `${normalizedBase}/${buildAttachmentPreviewPath(objectKey)}`;
}
